import { Link } from "react-router";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { themeMode, useThemeMode } from "@/stores/theme_mode";

function Footer() {
  const [theme] = useThemeMode();
  const isDark = theme === "dark";
  const themeLabel = isDark ? "Enable light mode" : "Enable dark mode";

  return (
    <footer className="bg-transparent py-8 text-sm text-muted-foreground print:hidden">
      <div className="app-container flex flex-col-reverse items-center justify-between gap-4 lg:flex-row">
        <div><span className="text-secondary-foreground">&copy; 2023-{new Date().getFullYear()}</span><Link className="ml-1 hover:text-foreground hover:underline" to="/about">Batu Ice</Link></div>
        <button type="button" className="inline-flex size-8 items-center justify-center rounded-sm transition-colors hover:bg-muted hover:text-foreground md:hidden" title={themeLabel} onClick={() => themeMode.switchMode()}>
          {isDark ? <IconSun className="size-5" aria-hidden="true" /> : <IconMoon className="size-5" aria-hidden="true" />}
          <span className="sr-only">{themeLabel}</span>
        </button>
      </div>
    </footer>
  );
}

export { Footer };
